<div class="pageTitle">Admin : Clients</div>
<div class="titleSpacerBelow">&nbsp;</div>

<!-- Filter and pagination row (outside sectionContainer like probate list) -->
<div class="client-filter-container">
  <div class="client-search-section">
    <input type="text" placeholder="Search by client name" [(ngModel)]="clientSearchTerm" (input)="onClientSearchInput()" (keydown)="onClientSearchKeydown($event)" class="client-search-input" />
    <input type="text" placeholder="Search by URN" [(ngModel)]="clientUrnSearchTerm" (input)="onClientUrnSearchInput()" (keydown)="onClientSearchKeydown($event)" class="client-search-input" />
    <button mat-raised-button color="primary" (click)="onClientSearch()" style="height:40px;">Search</button>
    <button mat-stroked-button (click)="clearClientSearch()" style="height:40px;">Clear</button>
    <button mat-raised-button class="addButton" (click)="addClient()">
      Add Client
    </button>
  </div>
  <div class="client-paginator">
    <mat-paginator [length]="filteredClients.length"
                   [pageSize]="pageSize"
                   [pageIndex]="pageIndex"
                   [pageSizeOptions]="pageSizeOptions"
                   (page)="pageChanged($event)"
                   showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

<div class="sectionContainer">
  <!-- Column headers -->
  <div class="client-header-grid header-row">
    <div>Name</div>
    <div>Associated Beneficiary</div>
    <div>Finance Client ID</div>
    <div>Tier</div>
    <div></div>
    <div>Actions</div>
  </div>

  <mat-accordion [multi]="false" style=" display: flex; flex-direction: column; gap:10px; margin-top:10px;">

    <mat-expansion-panel *ngFor="let client of paginatedClients; let i = index"
                         (opened)="onClientOpened(client)"
                         (closed)="onClientClosed(client)"
                         [expanded]="expandedClientId === client.id">

      <mat-expansion-panel-header>

        <div class="client-header-grid ">

          <div class="client-col-name">
            <ng-container *ngIf="client.isEdit; else viewName">
              <input type="text" class="client-edit-input"
                     [(ngModel)]="client.name"
                     placeholder="Client name"
                     (click)="$event.stopPropagation()"
                     (keydown)="$event.stopPropagation()" />
            </ng-container>
            <ng-template #viewName>
              <span [style.font-weight]="expandedClientId === client.id ? '700' : '400'">{{ client.name || 'New Client' }}</span>
            </ng-template>
          </div>
          <div class="client-col-beneficiary client-associated-beneficiary">
            <ng-container *ngIf="client.isEdit; else viewAB">
              <input type="text" readonly class="client-edit-input"
                     [value]="client.associatedBeneficiaryName || getAssociatedBeneficiaryDisplay(client)"
                     placeholder="No beneficiary linked"
                     (click)="$event.stopPropagation()" />
            </ng-container>
            <ng-template #viewAB>
              <span [style.font-weight]="expandedClientId === client.id ? '700' : '400'">
                {{ getAssociatedBeneficiaryDisplay(client) }}
              </span>
            </ng-template>
          </div>

          <div class="client-col-finance">
            <ng-container *ngIf="client.isEdit; else viewFC">
              <input type="text" readonly class="client-edit-input"
                     [value]="client.financeClientId || ''"
                     [placeholder]="client.financeClientId ? 'Linked' : 'No finance client linked'"
                     (click)="$event.stopPropagation()" />
            </ng-container>
            <ng-template #viewFC>
              <span [style.font-weight]="expandedClientId === client.id ? '700' : '400'" style="font-size:13px;">
                {{ client.financeClientId || '' }}
              </span>
            </ng-template>
          </div>

          <div class="client-col-tier" (click)="$event.stopPropagation()">
            <ng-container *ngIf="client.isEdit; else viewTier">
              <select class="client-edit-input" [(ngModel)]="client.pricingTierId"
                      (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()">
                <option *ngFor="let tier of pricingTiers" [ngValue]="tier.id">{{ tier.name }}</option>
              </select>
            </ng-container>
            <ng-template #viewTier>
              <span [style.font-weight]="expandedClientId === client.id ? '700' : '400'" style="font-size:13px;">
                {{ client.pricingTierName || '' }}
              </span>
            </ng-template>
          </div>

          <!-- Lookup buttons column: both buttons side by side, only visible in edit mode -->
          <div (click)="$event.stopPropagation()" style="display:flex; gap:8px; align-items:center;">
            <ng-container *ngIf="client.isEdit">
              <button mat-stroked-button class="search-btn" style="white-space:nowrap;"
                      (click)="$event.stopPropagation(); openBeneficiaryLookup(client)">Associate Beneficiary</button>
              <button mat-stroked-button class="search-btn" style="white-space:nowrap;"
                      (click)="$event.stopPropagation(); openFinanceClientLookup(client)">Finance Client Match</button>
            </ng-container>
          </div>

          <div class="client-actions" (click)="$event.stopPropagation()" *ngIf="expandedClientId !== client.id">

            <ng-container *ngIf="client.isEdit; else viewButtons">
              <button mat-icon-button (click)="cancelEdit(client)">
                <mat-icon>cancel</mat-icon>
              </button>
              <button mat-icon-button (click)="saveClient(client)">
                <mat-icon>save</mat-icon>
              </button>
            </ng-container>

            <ng-template #viewButtons>
              <button mat-icon-button (click)="editClient(client)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="deleteClient(client)">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-template>

          </div>

        </div>

      </mat-expansion-panel-header>

      <!-- Lazy loaded subscriptions -->
      <ng-container *ngIf="expandedClientId === client.id">
        <app-admin-client-subscriptions [clientId]="client.id"
                                        [clientName]="client.name"
                                        [loggedInUser]="loggedInUser">
        </app-admin-client-subscriptions>
      </ng-container>

    </mat-expansion-panel>

  </mat-accordion>

  <div class="results-count-updated" *ngIf="filteredClients.length >0">
    <p>Found {{filteredClients.length}} client(s).</p>
  </div>
</div>

<!-- Inline Beneficiary Lookup Overlay (matches dialog look/feel from admin-subscription-item-dialog) -->
<div class="charity-lookup-overlay" *ngIf="isBeneficiaryPopupOpen" (mousedown)="onBeneficiaryOverlayMouseDown($event)">
  <div class="charity-lookup-dialog" cdkDrag cdkDragBoundary=".charity-lookup-overlay" (mousedown)="$event.stopPropagation()">
    <div class="charity-lookup-header" cdkDragHandle>
      <h3>Beneficiary Lookup</h3>
      <button class="close-btn" (click)="closeBeneficiaryLookup()" title="Close">✕</button>
    </div>

    <div class="charity-lookup-content">
      <!-- SEARCH FIELDS -->
      <div class="search-fields-row">

        <div class="search-field search-field-large">
          <label style="text-align: center">Beneficiary Name</label>
          <div class="input-with-clear">
            <input type="text"
                   [(ngModel)]="beneficiarySearchQuery.beneficiaryName"
                   (keydown)="onBeneficiarySearchKeydown($event)"
                   placeholder="Enter beneficiary name"
                   class="search-input" />
            <button type="button" class="clear-input-btn"
                    [disabled]="!beneficiarySearchQuery.beneficiaryName"
                    (click)="beneficiarySearchQuery.beneficiaryName=''; onBeneficiarySearch()">
              ×
            </button>
          </div>
        </div>

        <div class="search-field search-field-urn">
          <label style="text-align: center">URN</label>
          <div class="input-with-clear">
            <input type="text"
                   [(ngModel)]="beneficiarySearchQuery.beneficiaryURN"
                   (keydown)="onBeneficiarySearchKeydown($event)"
                   class="search-input" />
            <button type="button" class="clear-input-btn"
                    [disabled]="!beneficiarySearchQuery.beneficiaryURN"
                    (click)="beneficiarySearchQuery.beneficiaryURN=''; onBeneficiarySearch()">
              ×
            </button>
          </div>
        </div>

        <div class="search-field search-field-postcode">
          <label style="text-align: center">Postcode</label>
          <div class="input-with-clear">
            <input type="text"
                   [(ngModel)]="beneficiarySearchQuery.postcode"
                   (keydown)="onBeneficiarySearchKeydown($event)"
                   class="search-input" />
          </div>
        </div>

        <div class="search-field search-field-address">
          <label style="text-align: center">Address</label>
          <div class="input-with-clear">
            <input type="text"
                   [(ngModel)]="beneficiarySearchQuery.address"
                   (keydown)="onBeneficiarySearchKeydown($event)"
                   class="search-input" />
          </div>
        </div>

        <div class="search-field search-field-button">
          <label>&nbsp;</label>
          <button class="search-btn" (click)="onBeneficiarySearch()">Search</button>
        </div>


      </div>
      <!-- NEW: Show selected only toggle for beneficiaries -->
      <div style="display: flex; align-items: center; gap:8px; padding-left:12px; justify-content: flex-end;">
        <label style="display:inline-flex; align-items:center; gap:6px;">
          <input type="checkbox" [checked]="showOnlySelectedBeneficiaries" (change)="toggleShowOnlySelectedBeneficiaries()" />
          <span style="font-size:12px; color:#243b6b; font-weight:600;">Show selected only</span>
        </label>
      </div>

      <!-- SEARCH RESULTS -->
      <div class="search-results-container items-scroll-wrapper">
        <div *ngIf="beneficiarySearchResults.length > 0" style="display:flex; justify-content:flex-end; padding: 4px 8px 4px;">
          <button mat-stroked-button (click)="openAddBeneficiaryDialog()"
                  style="font-size:12px; color: #243b6b; border-color: #243b6b;">
            + Add Beneficiary
          </button>
        </div>
        <table class="results-table" *ngIf="beneficiarySearchResults.length &gt;0">
          <thead style=" background: linear-gradient(90deg, #e8f0ff, #ffffff);">
            <tr>
              <th style="width:36px;"></th>
              <th>Name</th>
              <th>URN</th>
              <th>Postcode</th>
              <th>Address</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let result of beneficiarySearchResults; trackBy: trackById"
                (click)="selectBeneficiary(result)"
                [class.selected]="selectedBeneficiaryId === result.id">
              <td (click)="$event.stopPropagation()">
                <input type="radio" name="beneficiarySelect" [checked]="selectedBeneficiaryId === result.id" (change)="selectBeneficiary(result)" />
              </td>
              <td>
                <span #cell
                      (mouseenter)="showTooltip(result.id, result.aliases, result.previousNames, cell)"
                      (mouseleave)="hideTooltip(result.id)"
                      [style.font-weight]="result.isClient ? '900' : 'normal'"
                      style="cursor: pointer; display:inline-block;">
                  {{ result.name }}
                </span>
              </td>
              <td style="text-align:center">{{ result.beneficiarySourceURN }}</td>
              <td style="text-align:center">{{ result.postcode }}</td>
              <td>{{ result.addressLine1 }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Hover popup toolbox for alias & previous names (rendered outside table rows) -->
        <div *ngFor="let result of beneficiarySearchResults">
          <div *ngIf="tooltipVisible[result.id]" class="hover-card-fixed"
               [ngStyle]="{ top: tooltipPosition[result.id]?.top + 'px', left: tooltipPosition[result.id]?.left + 'px' }"
               (mouseenter)="onTooltipMouseEnter(result.id)"
               (mouseleave)="onTooltipMouseLeave(result.id)">
            <div class="tooltip-columns">
              <!-- Aliases Section -->
              <div class="tooltip-column">
                <div class="tooltip-section-header">Aliases</div>
                <ng-container *ngIf="tooltipContent[result.id]?.aliases?.length; else noAliases">
                  <div *ngFor="let alias of tooltipContent[result.id].aliases" class="tooltip-item">{{ alias }}</div>
                </ng-container>
                <ng-template #noAliases>
                  <div class="tooltip-item-empty">None</div>
                </ng-template>
              </div>

              <!-- Former Names Section -->
              <div class="tooltip-column">
                <div class="tooltip-section-header">Former Names</div>
                <ng-container *ngIf="tooltipContent[result.id]?.previousNames?.length; else noFormerNames">
                  <div *ngFor="let formerName of tooltipContent[result.id].previousNames" class="tooltip-item">{{ formerName }}</div>
                </ng-container>
                <ng-template #noFormerNames>
                  <div class="tooltip-item-empty">None</div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <!-- NO RESULTS + ADD BENEFICIARY -->
        <div class="no-results" *ngIf="beneficiarySearchResults.length === 0">
          <p>No results found.</p>
          <button mat-raised-button (click)="openAddBeneficiaryDialog()"
                  style="background: linear-gradient(135deg, #1e3a5f, #243b6b); color: white; margin-top: 12px;">
            + Add Beneficiary
          </button>
        </div>
      </div>

    </div>
    <!-- APPLY BUTTONS -->
    <div class="footer-btn" style="padding:12px; display:flex; justify-content:space-between; align-items:center;">
      <div class="results-count-updated">
        <p>Found {{beneficiarySearchResults.length}} results(s).</p>
      </div>
      <div style="display:flex; gap:5px">
        <button mat-button (click)="closeBeneficiaryLookup()" style=" background: #f1f5f9; border:1px solid #dbe3f8; color: #2f3f66;">Cancel</button>
        <button mat-raised-button style="background: linear-gradient(135deg, #7c3aed, #6d28d9); color: white;" (click)="saveBeneficiarySelection()">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- Finance Client Lookup Overlay -->
<div class="charity-lookup-overlay" *ngIf="isFinanceClientPopupOpen" (mousedown)="$event.target === $event.currentTarget && closeFinanceClientLookup()">
  <div class="charity-lookup-dialog" cdkDrag cdkDragBoundary=".charity-lookup-overlay" (mousedown)="$event.stopPropagation()"
       style="width:75%; max-width:1100px; height:auto; max-height:85vh; min-width:600px; min-height:500px;">
    <div class="charity-lookup-header" cdkDragHandle>
      <h3>{{ isCreatingFinanceContact ? 'Create New Xero Contact' : 'Finance Client Search' }}</h3>
      <button class="close-btn" (click)="closeFinanceClientLookup()" title="Close">✕</button>
    </div>

    <div class="charity-lookup-content">

      <!-- SEARCH VIEW -->
      <ng-container *ngIf="!isCreatingFinanceContact">
        <div class="search-fields-row">
          <div class="search-field" style="flex:1;">
            <label>Client Name</label>
            <input type="text" class="search-input"
                   [(ngModel)]="financeClientNameInput"
                   (ngModelChange)="onFinanceClientNameInput($event)"
                   placeholder="Type at least 3 characters to search" />
          </div>
        </div>
        <div class="search-results-container items-scroll-wrapper">
          <table class="results-table" *ngIf="financeClientSearchResults.length > 0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Addresses</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let contact of financeClientSearchResults"
                  (click)="selectFinanceContact(contact)"
                  style="cursor:pointer;">
                <td>{{ contact.Name }}</td>
                <td>{{ contact.EmailAddress }}</td>
                <td>{{ formatFinanceContactAddresses(contact) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="no-results" *ngIf="financeClientXeroError">
            <p style="color:#c0392b;">Xero is not authorised. Please reauthorise Xero in the Finance settings before searching.</p>
          </div>
          <div class="no-results" *ngIf="!financeClientXeroError && financeClientNameInput.length >= 3 && financeClientSearchResults.length === 0">
            <p>No matching Xero contact found.</p>
            <button mat-raised-button (click)="openCreateFinanceContact()"
                    style="background:linear-gradient(135deg,#1e3a5f,#243b6b); color:white; margin-top:12px;">
              + Create New Xero Contact
            </button>
          </div>
        </div>
      </ng-container>

      <!-- CREATE VIEW -->
      <div *ngIf="isCreatingFinanceContact" class="create-finance-contact-form">

        <div class="fc-form-section-title">Contact Details</div>
        <div class="fc-form-row">
          <div class="fc-form-field fc-form-field-wide">
            <label>Contact Name <span class="fc-required">*</span></label>
            <input type="text" class="search-input" [(ngModel)]="newFinanceContact.name"
                   placeholder="Organisation or contact name" />
          </div>
        </div>

        <div class="fc-form-section-title">Primary Person</div>
        <div class="fc-form-row">
          <div class="fc-form-field">
            <label>First Name</label>
            <input type="text" class="search-input" [(ngModel)]="newFinanceContact.firstName" placeholder="First name" />
          </div>
          <div class="fc-form-field">
            <label>Last Name</label>
            <input type="text" class="search-input" [(ngModel)]="newFinanceContact.lastName" placeholder="Last name" />
          </div>
          <div class="fc-form-field fc-form-field-wide">
            <label>Email</label>
            <input type="email" class="search-input" [(ngModel)]="newFinanceContact.emailAddress" placeholder="Email address" />
          </div>
        </div>

        <div class="fc-form-section-title">Billing Address</div>
        <div class="fc-form-row">
          <div class="fc-form-field fc-form-field-wide">
            <label>Address Line 1</label>
            <input type="text" class="search-input" [(ngModel)]="newFinanceContact.addressLine1" placeholder="Street address" />
          </div>
          <div class="fc-form-field">
            <label>City / Town</label>
            <input type="text" class="search-input" [(ngModel)]="newFinanceContact.city" />
          </div>
          <div class="fc-form-field">
            <label>County / Region</label>
            <input type="text" class="search-input" [(ngModel)]="newFinanceContact.region" />
          </div>
          <div class="fc-form-field fc-form-field-narrow">
            <label>Postcode</label>
            <input type="text" class="search-input" [(ngModel)]="newFinanceContact.postalCode" />
          </div>
          <div class="fc-form-field">
            <label>Country</label>
            <input type="text" class="search-input" [(ngModel)]="newFinanceContact.country" />
          </div>
        </div>

      </div>

    </div>

    <!-- FOOTER -->
    <div class="footer-btn" style="padding:12px; display:flex; justify-content:space-between; align-items:center;">
      <ng-container *ngIf="!isCreatingFinanceContact">
        <button mat-button (click)="closeFinanceClientLookup()"
                style="background:#f1f5f9; border:1px solid #dbe3f8; color:#2f3f66;">Cancel</button>
        <button mat-stroked-button (click)="openCreateFinanceContact()"
                style="color:#243b6b; border-color:#243b6b;">
          + Create New in Xero
        </button>
      </ng-container>
      <ng-container *ngIf="isCreatingFinanceContact">
        <button mat-button (click)="cancelCreateFinanceContact()"
                style="background:#f1f5f9; border:1px solid #dbe3f8; color:#2f3f66;">
          &#8592; Back to Search
        </button>
        <button mat-raised-button (click)="saveNewFinanceContact()"
                [disabled]="isCreatingFinanceContactSaving || !newFinanceContact.name?.trim()"
                style="background:linear-gradient(135deg,#1e3a5f,#243b6b); color:white;">
          {{ isCreatingFinanceContactSaving ? 'Saving to Xero...' : 'Save to Xero' }}
        </button>
      </ng-container>
    </div>

  </div>
</div>
